import { useContext, useEffect, useRef, useState } from 'react';
import { Dimensions } from 'react-native';
import { StateConfigContext } from '../providers';
var getBreakpointValue = (config, viewportWidth) => {
  var _a, _b, _c, _d;
  var breakpoint = 'xs';
  if (viewportWidth >= ((_a = config === null || config === void 0 ? void 0 : config.xl) === null || _a === void 0 ? void 0 : _a.breakpoint)) {
    breakpoint = 'xl';
  } else if (viewportWidth >= ((_b = config === null || config === void 0 ? void 0 : config.lg) === null || _b === void 0 ? void 0 : _b.breakpoint)) {
    breakpoint = 'lg';
  } else if (viewportWidth >= ((_c = config === null || config === void 0 ? void 0 : config.md) === null || _c === void 0 ? void 0 : _c.breakpoint)) {
    breakpoint = 'md';
  } else if (viewportWidth >= ((_d = config === null || config === void 0 ? void 0 : config.sm) === null || _d === void 0 ? void 0 : _d.breakpoint)) {
    breakpoint = 'sm';
  }
  return breakpoint;
};
var getBreakpointData = (breakPoints, viewportWidth, allowMdAsLargeScreen) => {
  var breakpoint = getBreakpointValue(breakPoints, viewportWidth);
  var config = {
    normal: breakpoint === 'lg' || breakpoint === 'xl',
    asMdLarge: breakpoint === 'md' || breakpoint === 'lg' || breakpoint === 'xl'
  };
  var isLargeScreen = allowMdAsLargeScreen ? config.asMdLarge : config.normal;
  return {
    breakpoint: breakpoint,
    isSmallScreen: !isLargeScreen,
    isLargeScreen: isLargeScreen
  };
};
export var useBreakpoint = props => {
  var _ref = props || {},
    _ref$allowMdAsLargeSc = _ref.allowMdAsLargeScreen,
    allowMdAsLargeScreen = _ref$allowMdAsLargeSc === void 0 ? false : _ref$allowMdAsLargeSc,
    _ref$returnAsObject = _ref.returnAsObject,
    returnAsObject = _ref$returnAsObject === void 0 ? false : _ref$returnAsObject;
  var _useContext = useContext(StateConfigContext),
    tokens = _useContext.tokens;
  var breakPoints = tokens === null || tokens === void 0 ? void 0 : tokens.breakPoints;
  var data = getBreakpointData(breakPoints, Dimensions.get('window').width, allowMdAsLargeScreen);
  var _useState = useState(data),
    breakpointValues = _useState[0],
    setBreakpointValues = _useState[1];
  var prevWidth = useRef(0);
  useEffect(() => {
    var listener = Dimensions.addEventListener('change', _ref2 => {
      var window = _ref2.window;
      if (prevWidth.current !== window.width) {
        prevWidth.current = window.width;
        var _data = getBreakpointData(breakPoints, window.width, allowMdAsLargeScreen);
        setBreakpointValues(_data);
      }
    });
    return () => {
      listener === null || listener === void 0 ? void 0 : listener.remove();
    };
  }, [breakPoints]);
  return !returnAsObject ? breakpointValues.breakpoint : breakpointValues;
};